import React, { useContext } from 'react';
import { Route, Redirect } from 'react-router-dom';
import _get from 'lodash/get';

import { AuthContext } from 'context/AuthContext';
import { IS_ALL_SSR } from 'dictionary';

export default function CanRoute({
  accessId = '',
  component: Component,
  isBlocked = false,
  redirectPath = '/',
  ...routeParams
}) {
  const { configuration } = useContext(AuthContext);

  const isConfigureRoute = accessId === 'admin.submenu.configure.enabled';
  const hasAccess = _get(configuration, accessId, false);
  const isEnabled = (IS_ALL_SSR && isConfigureRoute) || hasAccess;
  const isRouteable = isEnabled && !isBlocked;

  if (!configuration) return null;

  return (
    <Route
      {...routeParams}
      render={props =>
        isRouteable ? <Component {...props} /> : <Redirect to={redirectPath} />
      }
    />
  );
}
